const handleErrorMessage = (
  { response },
  dispatch,
  defaultMessage = 'error.OppsAnErrorHasOccurredTryAgainLater'
) => {

  if (response !== undefined) {

    if (response.status === 403) {
      setTimeout(() => {
        dispatch({
          type: 'CLOSE_SESSION',
          session: null,
        });
      }, 5000);
      return response.data?.mssg || 'Sesión expirada';
    } else {
      const resolvedMessage =
        response.data?.mssg ||
        response.data?.message ||
        response.data?.error?.mssg ||
        response.data?.error?.message ||
        defaultMessage;

      return resolvedMessage;
    }
  }

  return defaultMessage;
};

export default handleErrorMessage;
